<template>
  <!-- 走进武夷山 -->
  <div>
    <div style="position:relative">
      <TopButtom
        v-bind:buttonlist="buttonlist"
        v-on:changeDataList="changeDataList"
      ></TopButtom>
    </div>
    <!-- <CommonInfo  :info='info' v-show="deviceId==1"></CommonInfo> -->
    <TrafficInfoA :info='info' v-show="deviceId==2"></TrafficInfoA>
    <TrafficInfoB :info='info' v-show="deviceId==1"></TrafficInfoB>
    <TrafficInfoC :info='info' v-show="deviceId==3"></TrafficInfoC>
    <TrafficInfoD :info='info' v-show="deviceId==4"></TrafficInfoD>
  </div>
</template>

<script>
import "@/css/listVertical.css";
import CommonInfo from "@/components/common/commonInfo";
import TopButtom from "@/components/common/TopButtom.vue";
import TrafficInfoA from "@/views/traffic/trafficInfoA.vue";
import TrafficInfoB from "@/views/traffic/trafficInfoB.vue";
import TrafficInfoC from "@/views/traffic/trafficInfoC.vue";
import TrafficInfoD from "@/views/traffic/trafficInfoD.vue";
export default {
  name: "TabApage",
  components: {TopButtom,CommonInfo,TrafficInfoA,TrafficInfoB,TrafficInfoC,TrafficInfoD},
  data() {
    return {
      info:{},
      buttonlist: [
           {
          id: 1,
          leftS: "left:1.5625vw",
          leftX: "left:1.458vw",
          title: "飞机航班",
          noCheckX: false
        },
        {
          id: 2,
          leftS: "left:10.5208vw",
          leftX: "left:10.4167vw",
          title: "火车时刻",
          noCheckX: true
        },
        {
          id: 3,
          leftS: "left:19.479vw",
          leftX: "left:19.375vw",
          title: "汽车班次",
          noCheckX: true
        },
        {
          id: 4,
          leftS: "left:28.4375vw",
          leftX: "left:28.333vw",
          title: "自驾路线",
          noCheckX: true
        }
      ]
    };
  },
  watch: {
    deviceId: {
      handler(deviceId) {
        this.info = this.$store.state.info;
        this.buttonlist.forEach(element => { element.id == deviceId ? (element.noCheckX = false) : (element.noCheckX = true);});
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    deviceId() {
      return this.$store.state.tabPage;
    }
  },
  methods: {
    //切换标签
    changeDataList(type) {
      let name = "TrafficTab";
      this.$store.commit("setTabPage", type);
      this.$emit("specialtyListFunction", name);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/traffic/trafficTab.vue